<template>
  <div>
    <vx-card class="mt-base mb-5">
      <heading size="h2" style-size="h4" class="mb-5">{{ activityTitle }}</heading>
      <p>
        You would be surprised how hard and awkward this is. One of the many unglamorous things you
        will need to master as a nurse, is brushing someone else’s teeth! Because brushing teeth is
        a personal thing and has the potential to feel invasive to your patient, you also need to
        make them feel comfortable. This means speaking to them to reassure them and let them know
        what you are doing, and no sudden movements or surprises.
      </p>

      <div class="vx-row mt-10 flex-row-reverse">
        <div class="vx-col lg:w-1/2 md:w-1/2 w-full mb-base pl-10">
          <heading size="h3" style-size="h5" class="mb-5 text-underline">Videos:</heading>
          <p class="mb-5">
            1. How to Brush Someone Else's Teeth (don't forget to let them spit and rinse)
          </p>

          <video-trigger
            :imageSrc="videoTriggerImg1"
            button_id="brushing-teeth-1"
            @click="
              showVideoPopup(
                'https://www.youtube.com/embed/2-hpdRrrCiQ?autoplay=1',
                'brushing-teeth-1',
              )
            "
          ></video-trigger>
          <p class="my-5">.... and if you think that's hard, wait until you see this........</p>
          <video-trigger
            :imageSrc="videoTriggerImg2"
            button_id="brushing-teeth-2"
            @click="
              showVideoPopup(
                'https://www.youtube.com/embed/aJk0HA_dCZ8?autoplay=1',
                'brushing-teeth-2',
              )
            "
          ></video-trigger>
        </div>
        <div class="vx-col lg:w-1/2 md:w-1/2 w-full mb-base">
          <heading size="h3" style-size="h5" class="mb-5 text-underline">You will need:</heading>

          <ul class="default-list">
            <li>A volunteer willing to have you brush their teeth</li>
            <li>A new toothbrush</li>
            <li>Toothpaste</li>
            <li>Gloves</li>
            <li>A volunteer to take photos or a video (unless you can set it up yourself).</li>
            <li>To upload 3 photos or 1 video</li>
          </ul>

          <heading size="h3" style-size="h5" class="mb-5 text-underline">Your Task:</heading>

          <p class="mb-5">1. Watch the demonstration video on the right</p>
          <p class="mb-5">2. Follow this process to clean your volunteer's teeth</p>
          <p class="mb-5">3. Have someone photograph or video you doing this</p>

          <p class="mb-8 text-bold">
            Now answer the questions below (and upload your photos or video):
          </p>

          <label>
            <p>1. Describe how you found this task and what you found most challenging.</p>
            <textarea-block v-model="data.question1" :editable="isEditable" />
          </label>

          <label>
            <p>2. What did you learn from doing this activity?</p>
            <textarea-block v-model="data.question2" :editable="isEditable" />
          </label>

          <label>
            <p>3. Was it what you expected?</p>
            <switch-block v-model="data.question3" :editable="isEditable" />
          </label>

          <label>
            <p>4. Did your volunteer feel you did a good job?</p>
            <switch-block v-model="data.question4" :editable="isEditable" />
          </label>

          <label>
            <p>5. Upload your photos or video:</p>
            <br />
            <fileupload-button-immediate
              v-model="uploaded_files['uploaded_file_' + index]"
              :is-editable="isEditable"
              filetype="media"
              :index="index"
              v-for="index in 3"
              :key="index"
            />
          </label>

          <save-buttons :is-editable="isEditable" @save="save" />
        </div>
      </div>
    </vx-card>
  </div>
</template>

<script>
import methods from '@/views/WorkExperiences/components/activity_js/methods';
import computed from '@/views/WorkExperiences/components/activity_js/computed';
import inject from '@/views/WorkExperiences/components/activity_js/inject';
export default {
  data() {
    return {
      login_type: localStorage.getItem('login_type'),
      videoTriggerImg1: require('@/assets/images/experiences/nurse/how_to_brush_teeth_splash.png'),
      videoTriggerImg2: require('@/assets/images/experiences/nurse/brush_hippo_teeth_splash.png'),
      uploaded_files: {
        uploaded_file_1: '',
        uploaded_file_2: '',
        uploaded_file_3: '',
      },
    };
  },
  methods: methods,
  computed: computed,
  inject: inject,
  mounted() {
    if (typeof this.uploaded_files !== 'undefined') {
      for (let i = 1; i <= Object.keys(this.uploaded_files).length; i++) {
        if (typeof this.data['uploaded_file_' + i] !== 'undefined') {
          this.uploaded_files['uploaded_file_' + i] = this.data['uploaded_file_' + i];
        }
      }
    }
  },
};
</script>
